<template>
    <div class="animated fadeIn">
        <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-form>
            <b-form-group
                    description="New Password."
                    label="New Password"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input  type="password" v-model="newPassword"></b-form-input>
            </b-form-group>
          <b-form-group
            description="Confirm Password."
            label="Confirm Password"
            :label-cols="3"
            :horizontal="true">
            <b-form-input  type="password" v-model="confirmationPassword"></b-form-input>
          </b-form-group>
            <div slot="footer">
              <p class="error">{{ error }}</p>
              <update-password-button
                v-if="type === 'update'"
                :user-id="userId"
                :new-password="newPassword"
                :disabled="error === null ? false :true"
                @click="showLoading"
                @success="onChangeSuccess"
              ></update-password-button>
              <reset-password-button
                v-if="type === 'reset'"
                :user-id="userId"
                :new-password="newPassword"
                :disabled="error === null ? false :true"
                @click="showLoading"
              ></reset-password-button>
            </div>
        </b-form>
    </div>
</template>
<script>
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import UpdatePasswordButton from "./buttons/UpdatePasswordButton";
    import ResetPasswordButton from "./buttons/ResetPasswordButton";

    export default {
        name: 'change-password-form',
        components: {
          ResetPasswordButton,
          UpdatePasswordButton,
          VueLoading,
        },
        data() {
            return {
                isLoading: false,
                newPassword: null,
                confirmationPassword: null,
                error: null,
            }
        },
        props: {
            userId: {
                type: String,
                required: true,
            },
            type: {
              type: String,
              default: 'update'
            }
        },
        watch: {
            'newPassword': {
                handler(val) {
                    if (val !== this.confirmationPassword) {
                        this.error = 'Passwords dont match!'
                        return
                    }
                    this.error = null
                }
            },
            'confirmationPassword': {
                handler(val) {
                    if (val !== this.newPassword) {
                        this.error = 'Passwords dont match!'
                        return
                    }
                    this.error = null
                }
            },
        },
        methods: {
            showLoading() {
              this.isLoading = true
            },
            onChangeSuccess() {
              this.newPassword = '';
              this.confirmationPassword = '';
              this.isLoading = false;
              this.flash('Password Updated', 'success');
            },
        }
    }
</script>
